import * as React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {useTranslation} from '@utils/cache-translations';
import {useConfigs} from '@hooks/useConfigs';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    height: '100%'
  },
  scrollContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflowY: 'scroll'
  }
}));

export const DocumentSeeInstructionsModal = () => {
  const css = useStyles();
  const {uploadDocuments: {acceptableDocumentsUrl}} = useConfigs();
  const translations = useTranslation('i9DocumentUpload');
  return (
    <div className={css.scrollContainer}>
      <div>{translations.get('requiredDocumentsDescription')}</div>
      <ul>
        <li>{translations.get('requiredDocumentsLine1')}</li>
        <li>{translations.get('requiredDocumentsLine2')}</li>
        <li>{translations.get('requiredDocumentsLine3')}</li>
      </ul>
      <div>
        <span>
          <a href={acceptableDocumentsUrl} target={'_blank'}>
            {translations.get('requiredDocumentsLink')}
          </a>
          {translations.get('requiredDocumentsFooter')}
        </span>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/screens/review-section2/document-upload/document-see-instructions-modal.tsx